import { AccessControl, InputField } from "@components";
import { ADMIN_ROLE } from "@constants";
import {
  changePasswordAction,
  resetChangePasswordAction,
} from "@redux/actions";
import { useFormik } from "formik";
import React, { Fragment, useEffect } from "react";
import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { initialValues, validateSchema } from "./AccountSettingData";

const AccountSetting = () => {
  // state

  // variables
  const inputFields = [
    {
      label: "Current password",
      name: "oldPassword",
      type: "password",
      placeholder: "Enter your current password",
    },
    {
      label: "New password",
      name: "newPassword",
      type: "password",
      placeholder: "Enter your new password",
    },
    {
      label: "Confirm new password",
      name: "confirmPassword",
      type: "password",
      placeholder: "New password confirmation",
    },
  ];

  // logics before hooks

  // hooks
  const dispatch = useDispatch();
  const { passwordChanging } = useSelector((state) => state.user);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldError,
    resetForm,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: (values) => dispatch(changePasswordAction(values)),
  });

  // logics

  // UI partials
  const header = (
    <div>
      <h5>Your Cursus Account</h5>
      <small className="text-muted">
        This is your public presence on Cursus. You need a account to upload
        your paid courses, comment on courses, purchased by students, or
        earning.
      </small>
    </div>
  );
  const changePassword = (
    <Fragment>
      <Col xs={12}>
        <h5>Change password</h5>
        <small className="text-muted">
          Change your account's password and sign out.
        </small>
      </Col>
      <Form noValidate onSubmit={handleSubmit}>
        <Stack gap={3}>
          {inputFields.map((field, index) => (
            <Form.Group key={index} controlId={field.name}>
              <InputField
                readonly={passwordChanging.processing}
                required={true}
                label={field.label}
                name={field.name}
                type={field.type}
                placeholder={field.placeholder}
                value={values[field.name]}
                onChange={handleChange}
                onBlur={handleBlur}
                touchedValue={touched[field.name]}
                errorsValue={errors[field.name]}
              />
            </Form.Group>
          ))}
          <div>
            <Button type="submit">Change password</Button>
          </div>
        </Stack>
      </Form>
    </Fragment>
  );

  // effects
  useEffect(() => {
    if (!passwordChanging.processing && passwordChanging.data) {
      const { isSuccess, message } = passwordChanging.data;
      if (!isSuccess) setFieldError("oldPassword", message);
      else resetForm();
    }
  }, [passwordChanging.data]);

  useEffect(() => {
    dispatch(resetChangePasswordAction());
  }, [dispatch]);

  // render
  return (
    <Fragment>
      <AccessControl exceptRoles={[ADMIN_ROLE]}>
        <Fragment>
          <Row>{header}</Row>
          <div className="my-3 border-bottom"></div>
        </Fragment>
      </AccessControl>
      <Row className="gy-3 align-items-end justify-content-center">
        {changePassword}
      </Row>
    </Fragment>
  );
};

/* required: display name */
AccountSetting.displayName = "AccountSetting";

/* required: props types */
AccountSetting.propTypes = {};

/* required: default props */
AccountSetting.defaultProps = {};

export { AccountSetting };
